import CardTable from 'components/CardTable/CardTable'
import { useOpenComponent } from 'hooks/useOpenComponent'
import React, { useCallback, useMemo, useEffect } from 'react'
import AddIcon from "@mui/icons-material/Add";
import { columns } from './columns'
import {
  resetContractSelected,
  addContractMode,
  getContracts,
  getAllRules,
  editContractMode,
  changeContractSelected,
  deleteContractMode,
  handleContractsInputsAction
} from 'redux/actions/contractsCatalog/contractsCatalogActions'
import Description from '@mui/icons-material/Description'
import RegularButton from 'components/CustomButtons/Button'
import { useSearch } from 'hooks/useSearch'
import { ModalV2 } from 'components/Modal/ModalV2'
import { FormContractEdit } from './FormContractEdit'
import { TableInputs } from 'components/CardTable/TableInputs'
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { ColumnContainer } from 'utils/columnsStyle';
import { useDispatch, useSelector } from 'react-redux';
import { useRuleValidator } from "hooks/useRuleValidator";
import { PERMISSIONS } from "router/permissions";

const style = {
  color: '#004F9F',
  fontSize: 20,
  marginRight: 10,
  cursor: 'pointer'
}

const ActionsCell = ({ original }) => {
  const dispatch = useDispatch()
  const openEdit = () => {
    dispatch(editContractMode())
    original.modal()
    dispatch(changeContractSelected(original.id))
  }
  const openEliminate = () => {
    dispatch(deleteContractMode())
    original.modal()
    dispatch(changeContractSelected(original.id))
  }
  return (
    <ColumnContainer>
      <EditIcon style={style} onClick={openEdit} />
      <DeleteIcon style={{ ...style, color: '#e83737' }} onClick={openEliminate} />
    </ColumnContainer>
  )
}

export const ContractsCatalog = () => {
  const { setSnackbar } = useSearch();
  const { token, rules } = useSelector(state => state.login)
  const { rulesArr, contractsArr, addMode, deleteMode, station } = useSelector(state => state.contractsCatalog)
  const { isLoading } = useSelector((state) => state.search);
  const { isOpen, handleIsOpen } = useOpenComponent()
  const dispatch = useDispatch()
  const { PREPAYROLL_ADMIN } = PERMISSIONS
  const hasAdminPermission = useRuleValidator(PREPAYROLL_ADMIN)

  const mapContracts = useMemo(() =>
    contractsArr?.map(contract => ({
      ...contract,
      modal: handleIsOpen,
    })).flat() ?? [],
    [contractsArr, handleIsOpen]
  );

  const newColumns = useMemo(() => {
    const actions = {
      Header: "Acciones",
      filterable: false,
      sortable: false,
      Cell: ActionsCell,
    }
    return [...columns, ...(hasAdminPermission ? [actions] : [])]
  }, [rules, hasAdminPermission]);

  const fetchContracts = useCallback(
    (token, stationID) => {
      dispatch(getContracts(token, stationID));
    },
    [dispatch]
  );

  const handleSubmit = useCallback((e) => {
    if (e?.preventDefault) e.preventDefault()
    if (!station?.id) {
      setSnackbar("No se ha seleccionado alguna planta.");
      return;
    }
    fetchContracts(token, station.id);
  }, [token, station, setSnackbar, fetchContracts]);

  const handleClose = () => {
    dispatch(resetContractSelected())
    handleIsOpen()
  }

  const handleOpenAdd = () => {
    dispatch(addContractMode())
    handleIsOpen()
  }

  // Effects
  useEffect(() => {
    if (rulesArr.length === 0) dispatch(getAllRules(token))
  }, [dispatch, token, rulesArr])

  return (
    <React.Fragment>
      <CardTable
        icon={<Description />}
        title="Catalogo de Contratos"
        hasHeader
        data={mapContracts}
        columns={newColumns}
        loading={isLoading}
        blockBtn
        tableContent={
          <TableInputs
            reducer="contractsCatalog"
            stations
            dispatchAction={handleContractsInputsAction}
            submitAction={handleSubmit}
          />
        }
        hasControl
        controls={
          hasAdminPermission ?
            <RegularButton round justIcon color="info" onClick={handleOpenAdd}>
              <AddIcon style={{ margin: 0 }} />
            </RegularButton>
            : null
        }
      />

      <ModalV2
        open={isOpen}
        onClose={handleClose}
        toRight
        title={
          addMode
            ? 'Agregar nuevo contrato'
            : deleteMode ? '¿Estas seguro de eliminar este contrato?'
              : 'Modificar contrato'
        }
      >
        <FormContractEdit handleClose={handleClose} />
      </ModalV2>

    </React.Fragment>
  )
}
